import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, inject, OnInit, signal } from '@angular/core';
import { AppkitService } from '../../services/appkit.service';
import { AuthService } from '../../services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ContractService } from '../../services/contract.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
  selector: 'app-wallet-connect',
  imports: [],
  templateUrl: './wallet-connect.component.html',
  styleUrl: './wallet-connect.component.scss',
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class WalletConnectComponent implements OnInit {

  appkitService = inject(AppkitService);
  authService = inject(AuthService);
  contractService = inject(ContractService);
  toastr = inject(ToastrService);
  router = inject(Router);
  isProcessing = signal(false);
  
  // Get wallet state using signals
  isConnected = computed(() => this.appkitService.isConnected());
  walletAddress = computed(() => this.appkitService.currentAddress());
  isCorrectNetwork = computed(() => this.appkitService.isCurrentNetworkSupported());

  constructor() {
    // Effect to automatically call postNonce when wallet connects
    effect(() => {
      const connected = this.isConnected();
      const address = this.walletAddress();
      
      if (connected && address) {
        console.log('Wallet connected with address:', address);
        this.postNonce(address);
      }
    });
  }

  ngOnInit(): void {
  }

  /**
   * Opens wallet
   */
  openWallet() {
    this.isProcessing.set(true);
    this.appkitService.openConnectModal();
    this.isProcessing.set(false);
  }

  /**
   * Posts nonce
   * @param address
   * @returns
   */
  postNonce(address: string) {
    this.isProcessing.set(true);
    const walletAddress = address || this.walletAddress();
    
    if (!walletAddress) {
      console.error('No wallet address available for nonce request');
      return;
    }

    console.log('Requesting nonce for address:', walletAddress);
    this.authService.postRequestNonce(walletAddress).subscribe({
      next: (response: any) => {
        console.log('nonce response', response);
        this.getSignature(walletAddress, response.data.message)
      },
      error: (error: any) => {
        console.log('nonce error', error);
        this.toastr.error(error.error.message);
        this.isProcessing.set(false);
        this.appkitService.disconnectWallet();
      }
    })
  }

  /**
   * Gets signature
   * @param walletAddress
   * @param message
   */
  async getSignature(walletAddress: string, message: string) {
    try {
      const signature = await this.contractService.signMessage(walletAddress, message);
      console.log('signature', signature);
      this.postAuthentication(walletAddress, signature)
    } catch (err: any) {
      console.error('Error signing message:', err);
      this.toastr.error(err);
      this.isProcessing.set(false);
      this.appkitService.disconnectWallet();
      throw err;
    }
  }

  /**
   * Posts authentication
   * @param walletAddress
   * @param signature
   */
  postAuthentication(walletAddress: string, signature: string) {
    const payload = {
      "walletAddress": walletAddress,
      "signature": signature
    }
    this.authService.postAuthenticate(payload).subscribe({
      next: (response: any) => {
        console.log('auth response', response);
        localStorage.setItem('accessToken', response.data.token);
        localStorage.setItem('loginResponse', JSON.stringify(response.data.signer));
        this.toastr.success(response.message);
        this.isProcessing.set(false);
        this.router.navigate(['/propose-transaction']);
      },
      error: (error: any) => {
        console.log('auth error', error);
        this.toastr.error(error);
        this.isProcessing.set(false);
        this.appkitService.disconnectWallet();
      }
    })
  }
  
}
